<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入IP地址搜索"
                   @on-enter="searchinput"/>
            <Button type="primary" @click="searchinput" class="search-btn">搜索</Button>
            <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="600" size="small" border
                 :columns="columns" :data="tableData"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false width="520">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem label="IP地址" prop="ip">
                <Input v-model="formValidate.ip" placeholder="请输入IP地址，如 192.168.1.1"></Input>
              </FormItem>
              <FormItem label="类型" prop="type">
                <Select v-model="formValidate.type" style="width:200px">
                  <Option :value="1">正常</Option>
                  <Option :value="2">黑名单（拒绝访问）</Option>
                  <Option :value="3">白名单（直接放行）</Option>
                </Select>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
                <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
              </FormItem>
            </Form>
          </Modal>
          <!-- IP Access/Abnormal Record Modal -->
          <Modal v-model="ipRecordModalVisible" :title="ipRecordModalTitle" :loading=true :footer-hide=true
                 :mask-closable=false width="900">
            <Spin size="large" fix v-if="ipRecordSpinShow"></Spin>
            <Table height="400" size="small" border
                   :columns="ipRecordType === 'access' ? ipAccessColumns : ipAbnormalColumns"
                   :data="ipRecordData"></Table>
            <div style="margin: 10px; overflow: hidden">
              <div style="float: left;">
                <Page :total="ipRecordPageTotal" :current="ipRecordPageNum" :page-size="ipRecordPageSize"
                      :page-size-opts=[15,35,50,100] show-sizer show-total
                      @on-change="changeIpRecordPage" @on-page-size-change="handleIpRecordPageSize">
                </Page>
              </div>
            </div>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>
import {
  getSecurityIPList,
  operationSecurityIP,
} from '@/api/sys/security_ip.js'
import { getSecurityOverview } from '@/api/sys/security_overview.js'

export default {
  data() {
    return {
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: "",
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: "编辑"
      },
      editModalData: "",
      pageNum: 1,
      pageTotal: 0,
      pageSize: 15,

      // IP access/abnormal record modals
      ipRecordModalVisible: false,
      ipRecordModalTitle: '',
      ipRecordType: '',  // 'access' or 'abnormal'
      ipRecordData: [],
      ipRecordPageNum: 1,
      ipRecordPageTotal: 0,
      ipRecordPageSize: 15,
      ipRecordSpinShow: false,
      currentViewIp: '',
      ipAccessColumns: [
        { title: '序号', key: '_index', width: 65, align: 'center',
          render: (h, params) => { return h('span', params.index + 1 + (this.ipRecordPageNum - 1) * this.ipRecordPageSize); } },
        { title: 'IP', key: 'ip', align: 'center', minWidth: 140, tooltip: true },
        { title: '端口', key: 'port', align: 'center', width: 80 },
        { title: '方法', key: 'method', align: 'center', width: 80 },
        { title: '路径', key: 'path', align: 'center', minWidth: 180, tooltip: true },
        { title: '状态码', key: 'status_code', align: 'center', width: 80 },
        { title: '时间', key: 'create_time', align: 'center', minWidth: 160, tooltip: true }
      ],
      ipAbnormalColumns: [
        { title: '序号', key: '_index', width: 65, align: 'center',
          render: (h, params) => { return h('span', params.index + 1 + (this.ipRecordPageNum - 1) * this.ipRecordPageSize); } },
        { title: 'IP', key: 'ip', align: 'center', minWidth: 140, tooltip: true },
        { title: '原因', key: 'reason', align: 'center', minWidth: 150, tooltip: true },
        { title: '访问次数', key: 'access_count', align: 'center', width: 100 },
        { title: '时间窗口', key: 'time_window', align: 'center', minWidth: 120 },
        { title: '路径', key: 'path', align: 'center', minWidth: 180, tooltip: true },
        { title: '时间', key: 'create_time', align: 'center', minWidth: 160, tooltip: true }
      ],

      ruleValidate: {
        ip: [
          { required: true, message: "IP地址不能为空", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请选择类型", trigger: "change", type: 'number' }
        ]
      },
      columns: [
        {
          title: "序号",
          key: "_index",
          width: 65,
          align: "center",
          render: (h, params) => {
            return h("span", params.index + 1 + (this.pageNum - 1) * this.pageSize);
          }
        },
        {
          title: "IP地址",
          key: "ip",
          align: "center",
          minWidth: 140,
          tooltip: true
        },
        {
          title: "类型",
          key: "type",
          align: "center",
          width: 130,
          render: (h, params) => {
            const typeMap = { 1: '正常', 2: '黑名单', 3: '白名单' };
            const colorMap = { 1: 'default', 2: 'error', 3: 'success' };
            return h("Tag", {
              props: { color: colorMap[params.row.type] || 'default' }
            }, typeMap[params.row.type] || '未知');
          }
        },
        {
          title: "访问次数",
          key: "access_count",
          align: "center",
          width: 100
        },
        {
          title: "创建时间",
          key: "create_time",
          align: "center",
          minWidth: 150,
          tooltip: true
        },
        {
          title: "更新时间",
          key: "update_time",
          align: "center",
          minWidth: 150,
          tooltip: true
        },
        {
          title: "操作",
          key: "handle",
          fixed: "right",
          width: 380,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: { type: "primary", size: "small" },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.editModal(params.row, "put", "编辑");
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: { type: "success", size: "small" },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.openIpRecordModal(params.row, 'access');
                    }
                  }
                },
                "访问记录"
              ),
              h(
                "Button",
                {
                  props: { type: "warning", size: "small" },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.openIpRecordModal(params.row, 'abnormal');
                    }
                  }
                },
                "异常记录"
              ),
              h(
                "Button",
                {
                  props: { type: "error", size: "small" },
                  on: {
                    click: () => {
                      this.delData(params);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
    };
  },
  methods: {
    getSecurityIPList(key) {
      this.spinShow = true
      getSecurityIPList(this.pageNum, this.pageSize, key).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    delData(params) {
      if (confirm(`确定要删除IP ${params.row.ip} 吗？删除后将同步清理Redis缓存。`)) {
        operationSecurityIP({ 'id': params.row.id }, 'delete').then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.getSecurityIPList(this.searchVal)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    editModal(paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true;
      this.modalMap.modalTitle = mtitle;
      this.editModalData = meth;
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          ip: paramsRow.ip || '',
          type: paramsRow.type || 1
        }
      } else {
        this.formValidate = {
          id: 0,
          ip: '',
          type: 2
        }
      }
    },
    handleSubmit(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          const submitData = {
            id: this.formValidate.id,
            ip: this.formValidate.ip.trim(),
            type: this.formValidate.type
          }
          operationSecurityIP(submitData, this.editModalData).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.getSecurityIPList(this.searchVal)
              this.modalMap.modalVisible = false
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        } else {
          this.$Message.error("缺少必要参数");
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    changePage(value) {
      this.pageNum = value
      this.getSecurityIPList(this.searchVal)
    },
    handlePageSize(value) {
      this.pageSize = value
      this.pageNum = 1
      this.getSecurityIPList(this.searchVal)
    },
    searchinput() {
      this.pageNum = 1
      this.getSecurityIPList(this.searchVal)
    },
    // IP access/abnormal record methods
    openIpRecordModal(row, type) {
      this.currentViewIp = row.ip;
      this.ipRecordType = type;
      this.ipRecordModalTitle = type === 'access' ? `${row.ip} - 访问记录` : `${row.ip} - 异常记录`;
      this.ipRecordPageNum = 1;
      this.ipRecordPageSize = 15;
      this.ipRecordModalVisible = true;
      this.getIpRecordData();
    },
    getIpRecordData() {
      this.ipRecordSpinShow = true;
      const reqType = this.ipRecordType === 'access' ? 'access_records' : 'abnormal';
      getSecurityOverview({
        type: reqType,
        page: this.ipRecordPageNum,
        limit: this.ipRecordPageSize,
        key: this.currentViewIp
      }).then(res => {
        if (res.data.code === 0) {
          this.ipRecordPageTotal = res.data.count;
          this.ipRecordData = res.data.data;
        } else {
          this.$Message.error(`${res.data.msg}`);
        }
        this.ipRecordSpinShow = false;
      }).catch(() => {
        this.ipRecordSpinShow = false;
      });
    },
    changeIpRecordPage(value) {
      this.ipRecordPageNum = value;
      this.getIpRecordData();
    },
    handleIpRecordPageSize(value) {
      this.ipRecordPageSize = value;
      this.ipRecordPageNum = 1;
      this.getIpRecordData();
    },
  },
  mounted() {
    this.getSecurityIPList();
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col { display: inline-block; width: 200px; }
    &-input { display: inline-block; width: 200px; margin-left: 2px; }
    &-btn { margin-left: 2px; }
  }
}
</style>